/** 项目分包独立工作页：项目身份及访问校验完成后再加载合同工作区。
 * 原项目入口在抽屉中；分包工作页采用独立路由，避免在项目弹窗里再嵌套长表单。
 */
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useApp } from '../context/AppContext';
import ProjectSubcontracts from '../components/ProjectSubcontracts';
import SubcontractorContacts from '../components/SubcontractorContacts';
import { subcontractReturnUrl } from '../lib/subcontractWorkspace';
import { Button } from '../components/ui/button';

export default function ProjectSubcontractWorkspace() {
  const { id } = useParams();
  const { api, lang, user } = useApp();
  const location = useLocation();
  const zh = lang === 'zh';
  const [project, setProject] = useState(null), [error, setError] = useState(''), [tick, setTick] = useState(0);
  useEffect(() => {
    let active = true;
    setProject(null); setError('');
    api.get(`/projects/${id}/hub`).then(({ data }) => { if (active) setProject(data.project); }).catch(e => {
      if (active) setError(e.response?.status === 403 ? (zh ? '你没有此项目的访问权限。' : 'You do not have access to this project.') : (zh ? '项目加载失败，请重试。' : 'Unable to load project. Please retry.'));
    });
    return () => { active = false; };
  }, [api, id, tick, zh]);
  const back = location.state?.subcontractReturn;
  // 返回地址只接受应用内页面；刷新失去来源状态时回到工程看板对应项目。
  const source = typeof back === 'string' && back.startsWith('/') && !back.startsWith('//') ? back : `/board?project=${encodeURIComponent(id)}`;
  const [backPath, backSearch = ''] = source.split('?');
  const returnTo = subcontractReturnUrl(backPath, backSearch, id);
  return <div className="space-y-4 min-w-0" data-testid="subcontract-workspace-page">
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <Button asChild variant="ghost" className="shrink-0"><Link to={returnTo} data-testid="subcontract-back-project"><ArrowLeft className="h-4 w-4 mr-1" />{zh ? '返回项目' : 'Back to project'}</Link></Button>
      <div className="min-w-0"><h1>{zh ? '分包商管理' : 'Subcontractors'}</h1><h2 data-keep-title className="text-base font-semibold break-words">{project?.address || id}</h2></div>
    </div>
    {error ? <div role="alert" className="rounded-xl border border-border bg-card p-6"><p>{error}</p><Button variant="outline" className="mt-3" onClick={() => setTick(t => t + 1)}>{zh ? '重试' : 'Retry'}</Button></div>
      : !project ? <div role="status" className="p-8 flex items-center justify-center text-muted-foreground"><Loader2 className="mr-2 h-5 w-5 animate-spin" />{zh ? '加载项目…' : 'Loading project…'}</div>
        // 沿用原项目弹窗的销售可见范围；独立路由不能扩大到合同金额及付款资料。
        : user?.role === 'sales' ? <SubcontractorContacts key={id} projectId={id} /> : <ProjectSubcontracts key={id} projectId={id} />}
  </div>;
}
